
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Button, message } from "antd";
// import Logo from "../../src/assets/Logo.png";
// import NotificationBell from "../Components/NotificationBell";
// import {
//   HomeOutlined,
//   DashboardOutlined,
//   LogoutOutlined,
//   ContactsOutlined,
//   UserOutlined,
// } from "@ant-design/icons";


// const Navbar = ({ user, setUser }) => {
//   const navigate = useNavigate();

  
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkSize = () => setIsMobile(window.innerWidth <= 786);
//     checkSize();
//     window.addEventListener("resize", checkSize);
//     return () => window.removeEventListener("resize", checkSize);
//   }, []);

//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem("user");
//     message.success("Logged out successfully!");
//     navigate("/");
//   };

//   return (
//     <header
//       style={{
//         ...styles.header,
//         height: isMobile ? "60px" : "70px",
//         padding: isMobile ? "0 15px" : "0 40px",
//       }}
//     >
//       {/* LEFT: Brand */}
//       <Link to="/" style={styles.brand}>
//   <img
//     src={require("../../src/assets/Logo.png")}
//     alt="Yoga Refer.com"
//     style={{
//       height: isMobile ? "60px" : "70px",
//       width: "auto",
//       objectFit: "contain",
//     }}
//   />
// </Link>
      
//       {/* RIGHT NAV */}
//       <nav
//         style={{
//           ...styles.navLinks,
//           gap: isMobile ? "10px" : "20px",
//         }}
//       >
//         <Link to="/" style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}>
//           <HomeOutlined /> {!isMobile && "Home"}
//         </Link>

//         <Link to="/contact" style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}>
//           <ContactsOutlined /> {!isMobile && "Contact"}
//         </Link>

//         {user && (
//           <Link
//             to="/dashboard"
//             style={{ ...styles.link, fontSize: isMobile ? "14px" : "16px" }}
//           >
//             <DashboardOutlined /> {!isMobile && "Dashboard"}
//           </Link>
//         )}

//        {user ? (
//   <>
//     {/* Notification Bell */}
//     <NotificationBell role={user.role} />

//     <Button
//       type="default"
//       icon={<LogoutOutlined />}
//       size={isMobile ? "small" : "middle"}
//       onClick={handleLogout}
//     >
//       {!isMobile && "Logout"}
//     </Button>
//   </>
// ) : (
//   <Link to="/login">
//     <Button
//       type="primary"
//       icon={<UserOutlined />}
//       size={isMobile ? "small" : "middle"}
//     >
//       {!isMobile && "Login"}
//     </Button>
//   </Link>
// )}
        
//       </nav>
//     </header>
//   );
// };

// const styles = {
//   header: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     background: "linear-gradient(to right, rgb(255, 215, 0), rgb(255, 165, 0))",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     zIndex: 1000,
//     fontfamily: "manrope",
    
//   },

//   brand: {
//     color: "#13171bff",
//     fontWeight: "bold",
//     textDecoration: "none",
//   },
//   navLinks: {
//     display: "flex",
//     alignItems: "center",
//   },
//   link: {
//     color: "#333",
//     textDecoration: "none",
//   },
 
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, message } from "antd";
import {
  HomeOutlined,
  DashboardOutlined,
  LogoutOutlined,
  ContactsOutlined,
  UserOutlined,
} from "@ant-design/icons";
import NotificationBell from "../Components/NotificationBell";
import Logo from "../../src/assets/Logo.png";

const Navbar = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkSize = () => setIsMobile(window.innerWidth <= 786);
    checkSize();
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  const handleLogout = () => {
  sessionStorage.removeItem("token");   // ← add this
  sessionStorage.removeItem("user");    // ← add this
  setUser(null);
  navigate("/login");
};

  return (
    <header style={styles.header}>
      {/* LEFT: Logo */}
      <Link to="/">
        <img
          src={Logo}
          alt="YogaRefer.com"
          style={{ height: 54, width: "auto", objectFit: "contain", display: "block" }}
        />
      </Link>

      {/* RIGHT: Nav links + bell + logout */}
      <nav style={styles.navLinks}>
        <Link to="/" style={styles.link}>
          <HomeOutlined style={styles.linkIcon} />
          {!isMobile && <span>Home</span>}
        </Link>

        <Link to="/contact" style={styles.link}>
          <ContactsOutlined style={styles.linkIcon} />
          {!isMobile && <span>Contact</span>}
        </Link>

        {user && (
          <Link to="/dashboard" style={styles.link}>
            <DashboardOutlined style={styles.linkIcon} />
            {!isMobile && <span>Dashboard</span>}
          </Link>
        )}

        {user ? (
          <>
            <NotificationBell role={user.role} />

            <Button
              icon={<LogoutOutlined />}
              size={isMobile ? "small" : "middle"}
              onClick={handleLogout}
              style={styles.logoutBtn}
            >
              {!isMobile && "Logout"}
            </Button>
          </>
        ) : (
          <Link to="/login">
            <Button
              type="primary"
              icon={<UserOutlined />}
              size={isMobile ? "small" : "middle"}
              style={{ borderRadius: 20 }}
            >
              {!isMobile && "Login"}
            </Button>
          </Link>
        )}
      </nav>
    </header>
  );
};

const styles = {
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: 64,
    /* White on left fading into gold on the right — matches screenshot */
    background: "linear-gradient(to right, #ffffff 40%, #f9c74f 100%)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    zIndex: 1000,
    boxSizing: "border-box",
    fontFamily: "Manrope, sans-serif",
  },

  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    flexShrink: 0,
  },

  link: {
    color: "#333",
    textDecoration: "none",
    fontSize: 15,
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: 6,
    whiteSpace: "nowrap",
    transition: "color 0.2s",
  },

  linkIcon: {
    fontSize: 16,
  },

  logoutBtn: {
    borderRadius: 20,
    fontWeight: 600,
    borderColor: "#333",
    color: "#333",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
};

export default Navbar;

